import { render, staticRenderFns } from "./UserBonusList.vue?vue&type=template&id=34f3c1e6&scoped=true&"
import script from "./UserBonusList.vue?vue&type=script&lang=js&"
export * from "./UserBonusList.vue?vue&type=script&lang=js&"
import style0 from "./UserBonusList.vue?vue&type=style&index=0&id=34f3c1e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f3c1e6",
  null
  
)

export default component.exports